var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490.667,21.333H21.333C9.551,21.333,0,30.885,0,42.667v384C0,438.449,9.551,448,21.333,448h21.333v21.333 c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333V448h341.333v21.333 c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333V448h21.333c11.782,0,21.333-9.551,21.333-21.333v-384 C512,30.885,502.449,21.333,490.667,21.333z M469.333,405.333H42.667V64h426.667V405.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333,341.333c11.776,0,21.333-9.557,21.333-21.333s-9.557-21.333-21.333-21.333S384,308.224,384,320 S393.557,341.333,405.333,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333,192c11.776,0,21.333-9.557,21.333-21.333s-9.557-21.333-21.333-21.333S384,158.891,384,170.667 S393.557,192,405.333,192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.333,384h256c11.782,0,21.333-9.551,21.333-21.333v-256c0-11.782-9.551-21.333-21.333-21.333h-256 C73.551,85.333,64,94.885,64,106.667v256C64,374.449,73.551,384,85.333,384z M106.667,256h42.667v85.333h-42.667V256z  M234.667,256v85.333H192V256H234.667z M192,213.333V128h42.667v85.333H192z M277.333,341.333V256H320v85.333H277.333z  M320,213.333h-42.667V128H320V213.333z M149.333,128v85.333h-42.667V128H149.333z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.30ab42553ed9df21a2217eeb9f50efdb.svg";
export { ForwardRef as ReactComponent };